import React from "react";
import ResourcePage from "@/components/ResourcePage";

const STATUSES = ["Pending", "Completed", "Missed", "Rescheduled"];

export default function Followups() {
  return (
    <ResourcePage
      title="Follow-ups" name="Follow-up" endpoint="followups"
      subtitle="Never miss a buyer touchpoint — overdue items are highlighted"
      emptyMessage="No follow-ups scheduled. Schedule follow-ups from leads to stay on top of every buyer."
      relations={["buyers", "users"]}
      statusOptions={STATUSES}
      columns={[
        { key: "buyer_name", label: "Buyer" },
        { key: "assigned_name", label: "Owner" },
        { key: "followup_date", label: "Date", type: "date" },
        { key: "followup_type", label: "Type" },
        { key: "status", label: "Status", type: "status" },
      ]}
      defaultValues={{ status: "Pending", followup_type: "Email" }}
      formFields={[
        { name: "buyer_id", label: "Buyer", type: "relation", source: "buyers" },
        { name: "assigned_to", label: "Assigned to", type: "relation", source: "users" },
        { name: "followup_date", label: "Follow-up date", type: "date", required: true },
        { name: "followup_type", label: "Type", type: "select", options: ["Email", "Phone", "WhatsApp", "Meeting", "Other"] },
        { name: "status", label: "Status", type: "select", options: STATUSES },
        { name: "notes", label: "Notes", type: "textarea", full: true },
      ]}
    />
  );
}
